import Chip from '@mui/material/Chip';
import { ComponentProps } from 'react';

const CustomChip = ({
  label,
  icon,
  small = false,
  className = '',
  title,
}: {
  label: ComponentProps<typeof Chip>['label'];
  className?: string;
  small?: boolean;
  icon?: ComponentProps<typeof Chip>['icon'];
  title?: ComponentProps<typeof Chip>['title'];
}) => {
  return (
    <Chip
      icon={icon}
      size={small ? 'small' : 'medium'}
      className={[className, 'rounded-md uppercase font-light']
        .filter(Boolean)
        .join(' ')}
      label={label}
      title={title}
    />
  );
};

export default CustomChip;
